module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-9-zoom.69f61c68.png";